import { makeLoadingIds } from '../../../../shared/utils';

export const hisMvtIdsloadingValues = makeLoadingIds(10, 1);
